export enum RegistrationType {
  NotAllowed = 'NotAllowed',
  Classic = 'Classic',
  Freemium = 'Freemium'
}
